<app-select-input
    [form]="form()"
    id="doctorId"
    valueKey="id"
    labelKey="name"
    filterBy="name,surname,id,email,icpOfDoctor"
    [infiniteScroll]="doctorScroll()"
    [disabled]="disabled()"
>
    <ng-template #item let-item>
        <app-doctor-chip [doctor]="item"></app-doctor-chip>
    </ng-template>
    <ng-template #selectedItem let-item>
        <app-doctor-chip [doctor]="item" [renderDetails]="false"></app-doctor-chip>
    </ng-template>
</app-select-input>
